import { useEffect } from 'react';
export function useClickOutside(ref, handler) {
  useEffect(function () {
    var startedInside = null;
    var startedWhenMounted = null;
    var controller = new AbortController();

    var listener = function listener(event) {
      if (startedInside || !startedWhenMounted) return;
      if (!ref.current || ref.current.contains(event.target)) return;
      handler(event);
    };

    var validateEventStart = function validateEventStart(event) {
      startedWhenMounted = ref.current;
      startedInside = ref.current && ref.current.contains(event.target);
    };

    document.addEventListener('mousedown', validateEventStart, {
      signal: controller.signal
    });
    document.addEventListener('touchstart', validateEventStart, {
      signal: controller.signal
    });
    document.addEventListener('click', listener, {
      signal: controller.signal
    });
    return function () {
      controller.abort();
    };
  }, [ref, handler]);
}